/* unplugin-vue-components disabled */import { render } from "./KilaKilaCatalogCard.vue?vue&type=template&id=66587678&scoped=true"
import script from "./KilaKilaCatalogCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaCatalogCard.vue?vue&type=script&lang=js"

import "./KilaKilaCatalogCard.vue?vue&type=style&index=0&id=66587678&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66587678"]])

export default __exports__